import { Context } from "../Engine";
import { ITexture } from "./ITexture";

export class CubeMapTexture implements ITexture {
    public glTexture: WebGLTexture;
    public config: TextureSettings;
    public translucent: boolean;

    constructor(config: TextureSettings) {
        this.config = config;
        this.glTexture = null;
        this.translucent = false;
    }


    public async load(ctx: Context): Promise<CubeMapTexture> {
        let gl = ctx.gl;
        this.glTexture = gl.createTexture();

        let map = [
            { image: 'posx.jpg', glCubeMapSide: gl.TEXTURE_CUBE_MAP_POSITIVE_X },
            { image: 'negx.jpg', glCubeMapSide: gl.TEXTURE_CUBE_MAP_NEGATIVE_X },
            { image: 'posy.jpg', glCubeMapSide: gl.TEXTURE_CUBE_MAP_POSITIVE_Y },
            { image: 'negy.jpg', glCubeMapSide: gl.TEXTURE_CUBE_MAP_NEGATIVE_Y },
            { image: 'posz.jpg', glCubeMapSide: gl.TEXTURE_CUBE_MAP_POSITIVE_Z },
            { image: 'negz.jpg', glCubeMapSide: gl.TEXTURE_CUBE_MAP_NEGATIVE_Z }
        ];

        let onload = (img: HTMLImageElement, glCubeMapSide: number, done: () => void) => {
            return () => {
                gl.bindTexture(gl.TEXTURE_CUBE_MAP, this.glTexture);
                gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
                gl.texImage2D(glCubeMapSide, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, img);

                gl.bindTexture(gl.TEXTURE_CUBE_MAP, null);

                done();
            }
        };

        let promises = [];

        for (let item of map) {
            let promise = new Promise((resolve, reject) => {
                let image = new Image();
                image.onload = onload(image, item.glCubeMapSide, () => resolve());
                image.src = this.config.sourceDirectory + '/' + item.image;
            });


            promises.push(promise);
        }

        await Promise.all(promises);

        gl.bindTexture(gl.TEXTURE_CUBE_MAP, this.glTexture);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_NEAREST);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.generateMipmap(gl.TEXTURE_CUBE_MAP);
        gl.bindTexture(gl.TEXTURE_CUBE_MAP, null);

        return this;
    }
}

type TextureSettings = {
    sourceDirectory: string;
}
